export default function CreateMarketplace() {
  return (
    <div className="relative min-h-screen py-20 px-4">
      {/* Starfield Background */}
      <div className="fixed inset-0 -z-10">
        {[...Array(200)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              opacity: Math.random() * 0.5 + 0.3,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${Math.random() * 2 + 2}s`,
            }}
          />
        ))}
      </div>

      <div className="max-w-6xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-bold mb-16">
          Introducing Create NFT Marketplace
        </h1>

        {/* YouTube Video with White Glow */}
        <div className="mb-16 flex justify-center">
          <div className="relative inline-block rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(255,255,255,0.5)]">
            <iframe
              className="w-full max-w-6xl aspect-video rounded-2xl"
              src="https://www.youtube.com/embed/v46FxA7Jhc0"
              title="Create NFT Marketplace"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>

        {/* Description */}
        <div className="max-w-4xl mx-auto text-left space-y-6 text-lg leading-relaxed">
          <h2 className="text-3xl font-bold text-center mb-6">
            Create NFT Marketplace – Launching Soon: The World's First Universal NFT Marketplace!
          </h2>

          <p>
            Mandox is building a thriving ecosystem that bridges cryptocurrency and NFTs, with a mission to empower creators, support communities, and drive real-world impact. At the heart of this vision is Create – the groundbreaking NFT platform powered by Wire Blockchain, our official partner.
          </p>

          <p className="font-semibold">
            Create redefines what's possible in Web3 by eliminating common barriers:
          </p>

          <ul className="space-y-4 pl-6">
            <li className="flex items-start">
              <span className="mr-3 mt-1">•</span>
              <span><strong>Universal interoperability</strong> – Seamlessly mint, buy, sell, trade, and showcase NFTs across multiple blockchains without bridges, oracles, or hassle</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1">•</span>
              <span><strong>Zero gas fees</strong> – Powered by UPAP technology for ultra-low (or no) transaction costs, making it accessible for creators and collectors alike</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1">•</span>
              <span><strong>Social media-inspired features</strong> – Integrated P2P messaging, community feeds, NFT camera tools, cross-platform sharing, and direct creator-to-collector connections</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1">•</span>
              <span><strong>Artist-first design</strong> – Easy minting, exclusive drops, customizable profiles, and tools built by artists for artists</span>
            </li>
          </ul>

          <p>
            From digital art, music, memes, and collectibles to innovative Web3 projects, Create is the hub where creativity meets true accessibility, affordability, and social interaction in blockchain.
          </p>

          <p>
            The public beta has been tested, and the live release is coming soon – an experience like never before!
          </p>

          <p className="text-center text-xl font-bold mt-8">
            The future of NFTs is universal. Be part of it.
          </p>
        </div>

        {/* Logo above footer */}
        <div className="mt-6 mb-6 flex justify-center">
          <img
            src="https://static.lumi.new/74/743f3e27ef1a7bf6b22b770fcfc9fd6f.webp"
            alt="Create Logo"
            className="w-[768px] h-[768px] object-contain"
          />
        </div>
      </div>
    </div>
  )
}
